import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonRosterView component
 */
interface Props {
  bgColor: string;
}

/**
 * Pure view component for roster skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 */
const SkeletonRosterView = ({ bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="items-center gap-3 py-2">
      <Box
        className={`h-8 flex-1 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
      <Box
        className={`size-4 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonRosterView.displayName = "SkeletonRosterView";

export default memo(SkeletonRosterView);
